import { FileExtension, IFileExtensionContext } from 'tessa/ui/files';
import { Card, CardRow, CardRowState } from 'tessa/cards';
import { createCardModel, MenuAction, showError, showNotEmpty, UIButton, UIContext } from 'tessa/ui';
import { FileViewModel, GridViewModel } from 'tessa/ui/cards/controls';
import { MetadataStorage } from 'tessa';
import { CardNewRequest, CardRequest, CardService } from 'tessa/cards/service';
import { createTypedField, DotNetType, Guid, Visibility } from 'tessa/platform';
import { CdRequestTypes } from '../Helpers/CdRequestTypes';
import { showFormDialog } from 'tessa/ui/uiHost';

export class CdCheckSignsContextMenuFileExtension extends FileExtension {
  public async openingMenu(context: IFileExtensionContext) {
    let action = context.actions.find(action => action.name == "CheckEDS");
    if (!action) {
      return;
    }

    const card = UIContext.current.cardEditor!.cardModel!.card;

    let checkEDSActionIndex = context.actions.indexOf(action);
    context.actions[checkEDSActionIndex] = new MenuAction(
          "CheckEDS",
          "Проверить ЭП",
          "ta icon-thin-091",
          async () => await this.CheckSignsAsync(context.file, card),
        null,
        false);
  }

  private async CheckSignsAsync(
    file: FileViewModel,
    card: Card) {
    let checkSignsRequest: CardRequest = new CardRequest();
    checkSignsRequest.requestType = CdRequestTypes.CheckSigns;
    checkSignsRequest.info["CardID"] = createTypedField(card.id, DotNetType.Guid);
    checkSignsRequest.info["FileID"] = createTypedField(file.model.id, DotNetType.Guid);
    checkSignsRequest.info["FileVersionID"] = createTypedField(file.model.lastVersion.id, DotNetType.Guid);
    checkSignsRequest.info["FileName"] = createTypedField(file.model.lastVersion.name, DotNetType.String);
    let checkSignsResponse = await CardService.instance.request(checkSignsRequest);
    await showNotEmpty(checkSignsResponse.validationResult.build());
    if (!checkSignsResponse.validationResult.isSuccessful) {
      return;
    }

    let error = checkSignsResponse.info.Error?.$value;
    if (error) {
      await showError(error);
      return;
    }

    if (!checkSignsResponse.info.SignaturesInfo) {
      return;
    }

    let signaturesInfo =  checkSignsResponse.info.SignaturesInfo;

    let dialogsType = MetadataStorage.instance.cardMetadata.getCardTypeByName("PkDialogs");
    if (!dialogsType) {
      return;
    }

    let dialogForm = dialogsType.forms.find(x => x.name === "CheckSignsDialog");
    if (!dialogForm) {
      return;
    }

    let request = new CardNewRequest();
    request.cardTypeId = dialogsType.id;
    let response = await CardService.instance.new(request);
    response.card.id = Guid.newGuid();
    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
      return;
    }

    let windowCardModel = createCardModel(response.card, response.sectionRows);
    const pkCheckSignsVirtual = windowCardModel.card.sections.get("PkCheckSignsVirtual");
    if (!pkCheckSignsVirtual) {
      return;
    } 

    signaturesInfo.forEach(signature => {
         let roleRow = new CardRow();
          roleRow.rowId = Guid.newGuid();
          roleRow.set("SubjectName",  signature.SubjectName);
          roleRow.set("Company", signature.Company);
          roleRow.set("Date", signature.Date);
          roleRow.set("Event", signature.Event);
          roleRow.set("CadesType", signature.CadesType);
          roleRow.set("UserName", signature.UserName);
          roleRow.set("Comment", signature.Comment);
          roleRow.set("ErrorText", signature.ErrorText);
          roleRow.state = CardRowState.Inserted;
          pkCheckSignsVirtual.rows.push(roleRow);
    });

    await showFormDialog(
      dialogForm,
      windowCardModel,
      async (viewModel) => {
        let block = viewModel.blocks[0];
        if (!block) {
          return;
        }

        let contentControl = block.controls.find(x => x.name == "CheckSignsTable") as GridViewModel;
        if (!contentControl) {
          return;
        }

        contentControl.addButton.setVisibility(Visibility.Collapsed);
        contentControl.removeButton.setVisibility(Visibility.Collapsed);
        contentControl.rows.forEach(r => {
            let errorText = r.row.tryGet("ErrorText");
            if (errorText)
            {
                r.style.backgroundColor = "rgb(255, 0, 0)";
            }
        });
      },
      [
        new UIButton('$UI_Common_OK', async (btn) => {
          btn.close();
        })
      ]
    );
  }
}